export const bgMainHeader = require('./bg-header.png?webp');
export const truck1 = require('./truck-1.png?webp');
export const truck2 = require('./truck-2.png?webp');
export const cityPicture = require('./city.png?webp');
export const shipBg = require('./ship-bg.png?webp');
